var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Fily;
(function (Fily) {
    var PasswordToggle = (function (_super) {
        __extends(PasswordToggle, _super);
        function PasswordToggle() {
            var _this = _super.call(this, {}) || this;
            _this.delegateEvent();
            return _this;
        }
        PasswordToggle.prototype.events = function () {
            return {
                "click / .js-password-toggle": "toggle",
            };
        };
        PasswordToggle.prototype.toggle = function (event) {
            var icon = event.target;
            var input = icon.previousElementSibling;
            var type = input.getAttribute("type");
            input.setAttribute("type", type === "password" ? "text" : "password");
            icon.classList.toggle("is-visible");
        };
        return PasswordToggle;
    }(Fily.BaseView));
    Fily.PasswordToggle = PasswordToggle;
})(Fily || (Fily = {}));
